import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'paymentForm.title',
    defaultMessage: 'Your information',
  },
  firstName: {
    id: 'paymentForm.firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'paymentForm.lastName',
    defaultMessage: 'Second name',
  },
  email: {
    id: 'paymentForm.email',
    defaultMessage: 'Email address',
  },
  secure: {
    id: 'paymentForm.secure',
    defaultMessage: 'Secure payment',
  },
  genericError: {
    id: 'paymentForm.genericError',
    defaultMessage: 'Payment has failed. Please ensure that provided card data is valid',
  },
  fieldRequired: {
    id: 'paymentForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  incorrectEmailFormat: {
    id: 'paymentForm.incorrectEmailFormat',
    defaultMessage: 'This is not a valid e-mail format',
  },
  notYou: {
    id: 'paymentForm.notYou',
    defaultMessage: 'Not you? {logOut}',
  },
  logOut: {
    id: 'paymentForm.logOut',
    defaultMessage: 'Log out',
  },
});
